import * as React from 'react';
import { GroupPageTabProps } from './GroupInterfaces';
import './style.scss';
import classnames from 'classnames';
import apiService from '../../../services/api-service';
import { adjustForEmc3Format } from '../utils/helpers';

const GroupPageTab: React.FC<GroupPageTabProps> = (props) => {
	const [activePiId, setActivePiId] = React.useState<number>(
    props.tab.piIds[0]?.piId
	);
	const [activeDocument, setActiveDocument] = React.useState<string>();
	const { setIsBlackTriangleValue } = props;
	const { setTocValue } = props;
	const { setPiMetadataValue } = props;

	React.useEffect(() => {
		console.log(
			props.tab,
			props.tab.piIds,
			props.tab.piIds[0],
      props.tab.piIds[0]?.piId
		);
	}, [props.tab]);

	React.useEffect(() => {
		if (!activePiId) {
			return;
		}

    props.tab?.piIds.map(
      (pi) =>
      	pi.piId === activePiId &&
        setPiMetadataValue({
        	...pi,
        	companyName: props.companyName,
        })
    );
    apiService
    	.fetchData(`${props.path}piIds/${activePiId}/content.html`)
    	.then((res) => {
    		if (res) {
    			setActiveDocument(adjustForEmc3Format(res.data).innerHTML);
    		}
    	});
    apiService
    	.fetchData(`${props.path}piIds/${activePiId}/toc.html`)
    	.then((res) => {
    		if (res) {
    			setTocValue(res.data);
    		}
    	});
    // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activePiId, props.path, props.tab]);

	React.useEffect(() => {
		if (activeDocument) {
			const isBT = `${activeDocument}`.includes('class="aisBlackTriangle"');
			setIsBlackTriangleValue(isBT);
		}
	}, [activeDocument, setIsBlackTriangleValue]);

	React.useEffect(() => {
		const activePI = props.tab.piIds.find(pi => pi.piId === activePiId);
		if (activePI) {
			(window as any).dataLayer = (window as any).dataLayer || [];
			(window as any).dataLayer.push({
				event: 'pi_load',
				groupId: props.groupId,
				companyId: props.companyId,
				piId: activePI.piId,
				documentId: activePI.id,
			});
		}
	}, [activePiId, props.companyId, props.groupId, props.tab.piIds]);

	return (
		<div className="formTabContainer">
			{activePiId && (
				<div className="buttonsContainer">
					{props.tab.piIds.map((pi, i) => (
						<button
							key={i}
							className={classnames('button', {
								active: pi.piId === activePiId,
							})}
							onClick={() => setActivePiId(pi.piId)}
						>
							{pi.title.length > 100
								? `${pi.title.substring(0, 100)}...`
								: pi.title}
						</button>
					))}
				</div>
			)}
			{props.preview && (
				<div className="noticePreview">
          THIS INFORMATION IS NOT LIVE. THIS IS A PREVIEW
				</div>
			)}
			<div className="noticeTitle">
        This information is intended for use by health professionals
			</div>
			{activeDocument ? (
				<div
					className="body"
					dangerouslySetInnerHTML={{ __html: `${activeDocument}` }}
				/>
			) : (
				<div className="body">loading...</div>
			)}
		</div>
	);
};

export default GroupPageTab;
